import { render, staticRenderFns } from "./ParamsInfo.vue?vue&type=template&id=9f05cd42"
import script from "./ParamsInfo.vue?vue&type=script&lang=js"
export * from "./ParamsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports